// extracted by mini-css-extract-plugin
module.exports = {"title":"ModalTitle_title__3Hwuq"};